var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { GoogleMapComponent } from '../gmaps/google-map/google-map.component';
import { BaseComponent } from './base-component';
var ContactBaseComponent = /** @class */ (function (_super) {
    __extends(ContactBaseComponent, _super);
    function ContactBaseComponent(injector, agencyService, window) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.window = window;
        _this.travelModes = [];
        return _this;
    }
    ContactBaseComponent.prototype.ngOnInit = function () {
        this.setTitle('Contact ' + this.agencyService.agency.name);
    };
    return ContactBaseComponent;
}(BaseComponent));
export { ContactBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/contact-base.component.ts.pre-build-optimizer.js